export const CITY = 'City';
export const ZIP_CODE = 'ZipCode';
export const COMMUNITY = 'Provider';
